module.exports = "/fonts/vendor/line-awesome/dist/line-awesome/la-brands-400.woff2?54b0b4e7de85711c3796882b2b19eb00";